const Footer = () => <footer>Footer Content</footer>;
export default Footer;